module.exports = __webpack_public_path__ + "img/new-icon.93dcba97.svg";